module.exports = __webpack_public_path__ + "static/media/vote-1.643fc1d3.jpg";